var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.924,
    height: 45.924,
    viewBox: "0 0 45.924 45.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18690",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18690",
    transform: "translate(-512 -473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_5683",
    "data-name": "\\u6955\\u5186\\u5F62 5683",
    transform: "translate(512 473)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.962,
    cy: 22.962,
    r: 22.962,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.962,
    cy: 22.962,
    r: 22.462,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(524.999 485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25080",
    "data-name": "\\u30D1\\u30B9 25080",
    d: "M5.27,6.121a.77.77,0,0,1-.77-.77V2.27a.77.77,0,0,1,1.54,0V5.351A.77.77,0,0,1,5.27,6.121Zm9.242,0a.77.77,0,0,1-.77-.77V2.27a.77.77,0,0,1,1.54,0V5.351A.77.77,0,0,1,14.513,6.121Z",
    transform: "translate(0.122 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25081",
    "data-name": "\\u30D1\\u30B9 25081",
    d: "M19.215,20.985H3.811A2.313,2.313,0,0,1,1.5,18.674V4.811A2.313,2.313,0,0,1,3.811,2.5h15.4a2.313,2.313,0,0,1,2.311,2.311V18.674A2.313,2.313,0,0,1,19.215,20.985ZM3.811,4.04a.77.77,0,0,0-.77.77V18.674a.77.77,0,0,0,.77.77h15.4a.77.77,0,0,0,.77-.77V4.811a.77.77,0,0,0-.77-.77Z",
    transform: "translate(-1.499 -0.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25082",
    "data-name": "\\u30D1\\u30B9 25082",
    d: "M20.755,7.04H2.27a.77.77,0,1,1,0-1.54H20.755a.77.77,0,0,1,0,1.54ZM7.662,8.581H9.2v1.54H7.662Zm3.081,0h1.54v1.54h-1.54Zm3.081,0h1.54v1.54h-1.54Zm3.081,0h1.54v1.54H16.9ZM4.581,11.662h1.54V13.2H4.581Zm3.081,0H9.2V13.2H7.662Zm3.081,0h1.54V13.2h-1.54Zm3.081,0h1.54V13.2h-1.54Zm3.081,0h1.54V13.2H16.9ZM4.581,14.742h1.54v1.54H4.581Zm3.081,0H9.2v1.54H7.662Zm3.081,0h1.54v1.54h-1.54Z",
    transform: "translate(-1.499 0.662)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/scheduleIcon.e1f0c3d3ac6a601255feb2f482ea9908.svg";
export { ForwardRef as ReactComponent };